var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.779 6.72121C27.6175 -1.44027 14.3827 -1.44027 6.22121 6.72121C-1.94027 14.8827 -1.94027 28.1616 6.22121 36.279C14.3827 44.4405 27.6616 44.4405 35.779 36.279C43.9405 28.1175 43.9405 14.8827 35.779 6.72121ZM25.6323 29.7057L21.0001 25.0735L16.3679 29.7057C15.3974 30.6762 13.8092 30.7204 12.7945 29.7057C11.824 28.7351 11.7798 27.147 12.7945 26.1323L17.4267 21.5001L12.7945 16.8679C11.824 15.8974 11.7798 14.3092 12.7945 13.2945C13.7651 12.3239 15.3532 12.2798 16.3679 13.2945L21.0001 17.9267L25.6323 13.2945C26.6028 12.3239 28.191 12.2798 29.2057 13.2945C30.1762 14.2651 30.2204 15.8532 29.2057 16.8679L24.5735 21.5001L29.2057 26.1323C30.1762 27.1028 30.2204 28.691 29.2057 29.7057C28.191 30.6321 26.6028 30.6762 25.6323 29.7057Z",
    fill: "#C8923B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardIcon);
export default __webpack_public_path__ + "static/media/DiscardIcon.63b1da0acb4c3f0bea1189386eb61f30.svg";
export { ForwardRef as ReactComponent };